import React from 'react';
import Container from "./Container";
import Asset from "./Asset";
import classNames from "classnames";

const AssetGroup = ({ group, showDecommissioned, selectedAsset, onSelectAsset, containsGroups, dependenciesOfSelected, dependentsOfSelected }) => (
  <Container
    className={classNames(
      'asset-group',
      {
        'text-muted': group.decommissioned,
        'has-link': group.link != null,
        'selected': group == selectedAsset || (group.assets && group.assets.includes(selectedAsset)),
        'dependent-of-selected': dependentsOfSelected && dependentsOfSelected.includes(group.id)
      }
    )}
    group={group}
    href={group.link}
    icon={group.decommissioned ? 'fa-ban' : group.icon}
    title={group.name}
    onSelectAsset={onSelectAsset}
    startsExpanded={containsGroups}
    isDependency={dependenciesOfSelected && dependenciesOfSelected.includes(group.id)}
  >
    {
      (containsGroups) ?
        <div className='asset-group-listing'>
          {
            group.assetGroups.map(
              nestedGroup => (
                <AssetGroup
                  key={nestedGroup.id}
                  group={nestedGroup}
                  dependencies={group.dependencies}
                  showDecommissioned={showDecommissioned}
                  selectedAsset={selectedAsset}
                  onSelectAsset={onSelectAsset}
                  containsGroups={nestedGroup.assetGroups && nestedGroup.assetGroups.length > 0}
                  dependenciesOfSelected={dependenciesOfSelected}
                  dependentsOfSelected={dependentsOfSelected}
                />
              )
            )
          }
        </div>
        : null
    }
    {
      (group.assets && group.assets.length) ?
        <div className='asset-listing'>
          {
            group.assets.filter(
              a => showDecommissioned || !a.decommissioned
            ).map(
              asset => (
                <Asset
                  key={asset.id}
                  asset={asset}
                  dependencies={group.dependencies}
                  dependents={group.dependents}
                  selectedAsset={selectedAsset}
                  onSelectAsset={onSelectAsset}
                />
              )
            )
          }
        </div>
        : null
    }
  </Container>
);

export default AssetGroup;
